import React from 'react';
const stats = [{
  value: '+1.200',
  label: 'estudiantes confían'
}, {
  value: '6+6',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'LG',
  quote: '"Llegué a segundo año con apuntes de cinco compañeras que no coincidían entre sí. Con el Megapack tuve por primera vez un sistema claro para saber qué estudiar y en qué orden. Aprobé Adulto y Anciano con 9."',
  author: '— Laura G., Córdoba | 2° año Enfermería'
}, {
  initials: 'MR',
  quote: '"Siempre llegaba a los parciales sin saber si había estudiado lo correcto. Eso cambió: tengo el contenido organizado por ejes, sé cómo armar el PAE y llegué a los finales mucho más tranquilo. Ya aprobé 5 materias."',
  author: '— Martín R., Buenos Aires | 3° año Enfermería'
}, {
  initials: 'SV',
  quote: '"Estaba a punto de recursar Farmacología porque no encontraba material que se entienda. El Megapack tiene todo explicado con el lenguaje que usan en las cursadas. Los cálculos de dosis me dejaron de dar miedo."',
  author: '— Sofía V., Rosario | 2° año Enfermería'
}];
export function SocialProof() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,249,255) 0%, rgb(219,234,254) 20%, rgb(191,219,254) 70%, rgb(219,234,254) 100%)'
  }} data-id="element-293">
      <div className="mx-auto max-w-4xl" data-id="element-294">
        {/* ── STATS GRID ── */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-295">
          {stats.map(stat => <div key={stat.label} data-id="element-296">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-gray-900" data-id="element-297">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold text-blue-700" data-id="element-298">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* ── TESTIMONIALS GRID ── */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-299">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white/80 border border-blue-400/30 rounded-lg p-3 shadow-sm" data-id="element-300">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-black text-blue-700" style={{
            backgroundImage: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(191,219,254) 100%)'
          }} data-id="element-301">
                {t.initials}
              </div>
              <div data-id="element-302">
                <div className="mb-1 text-[10px] text-blue-600" data-id="element-303">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-900 m-0" data-id="element-304">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-305">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}